import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { RangeDatePicker } from "@gravity-ui/date-components";
import { dateTime } from "@gravity-ui/date-utils";
import { Card } from "@gravity-ui/uikit";
import { Loading } from "@/layouts/components/Loading";
import { RoutesList } from "@/router/routesList";
import { useGetPlaceSlotsQuery } from "@/store/api";
import { DATE_SERV_FORMAT, DATE_VIEW_FORMAT } from "@/tools/constants";
import { GridSlots } from "./GridSlots";
/** Дни со слотами расписания */
export var GridSchedule = function (props) {
    var _a, _b;
    var startDate = dateTime();
    var stopDate = startDate.add(6, "day");
    var _c = useState({
        start: startDate,
        end: stopDate,
    }), range = _c[0], setRange = _c[1];
    var placeSlotsGetSate = useGetPlaceSlotsQuery({
        id: props.placeId || "",
        startDate: ((_a = range.start) === null || _a === void 0 ? void 0 : _a.format(DATE_SERV_FORMAT)) || "",
        stopDate: ((_b = range.end) === null || _b === void 0 ? void 0 : _b.format(DATE_SERV_FORMAT)) || "",
    });
    useEffect(function () {
        if (props.refreshToken) {
            placeSlotsGetSate.refetch();
        }
    }, [placeSlotsGetSate.refetch, props.refreshToken]);
    var updateRangeDateHandler = function (value) {
        setRange(value);
    };
    var navigate = useNavigate();
    var successBookingHandler = function (gameId) {
        navigate(RoutesList.Game.getGameEdit(gameId));
    };
    var successDleteHandler = function () {
        navigate(RoutesList.Game.getGamesList());
    };
    return (_jsxs("div", { children: [_jsx(Loading, { isActive: !placeSlotsGetSate.isSuccess, loadingKey: "grid" }), _jsx(RangeDatePicker, { onUpdate: updateRangeDateHandler, format: DATE_VIEW_FORMAT, defaultValue: range, size: "xl" }), placeSlotsGetSate.isSuccess &&
                placeSlotsGetSate.data.days.map(function (day) { return (_jsx(Card, { style: { marginTop: 10 }, children: _jsxs("div", { style: { padding: 10 }, children: [_jsx("strong", { style: day.timeSlots.length ? undefined : { color: "red" }, children: dateTime({ input: day.date }).format("LL") }), _jsx("div", { children: dateTime({ input: day.date }).format("dddd") }), _jsx(GridSlots, { day: day, placeId: props.placeId, onClick: props.onClick ? function (slot) { return props.onClick(day, slot); } : undefined, onSuccessBooking: successBookingHandler, onSuccessCancel: successDleteHandler })] }) }, day.date)); })] }, placeSlotsGetSate.fulfilledTimeStamp));
};
